<template>
  <div class ="ProposalReview">
  <!--
  <v-container v-if="!showComponent">
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols=6>
                    <div class="text-h2 text-center primary--text font-weight-light">
                        Loading Proposal Review
                        <v-progress-circular indeterminate color="primary" class="mr-2" v-on="on"></v-progress-circular>    
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
    <v-container v-else fluid class="pt-lg-0">
    -->
        <v-container fluid class="pt-lg-0">
            <v-row>
                <v-col cols="12">
                    <v-row
                    align="center"
                    justify="center"
                    >
                    <v-card
                    max-width="1200"
                    :min-width=min_width
                    flat
                    class="pt-lg-0"
                    >
                        <v-col cols="12" class="pb-0 pt-lg-0">
                            <v-container class="pb-0 pt-lg-0">
                                <v-row>
                                    <v-col cols="12" class="pt-lg-0">
                                        <div class="text-h3 font-weight-light primary--text text-center">
                                            Proposal - Review Information
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-card>
                    <v-card
                    max-width="1200"
                    :min-width=min_width
                    outlined
                    class="rounded-card"
                    >
                        <v-card-text>
                            <v-row justify="center">
                                <v-col cols="11" class="mb-8 pa-2">
                                    <ProposalReviewGeneralInfo />
                                    <!--
                                    <v-row>
                                        <v-col cols="12" class="pb-0">
                                            <v-container class="pt-0">
                                                <div class="text-xl-h4 text-h6 font-weight-regular">Pricing Summary</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row class="primary mb-6">
                                        <v-col cols=6 md=2 class="pr-0">
                                            <v-container class="pa-0">
                                                <div class="font-weight-regular white--text"> 
                                                    <span class="font-weight-bold">Option 3(16):</span>
                                                    {{pricingSection.three_sixteen.is_checked}}
                                                </div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols=6 md=4>
                                            <v-container class="pa-0">
                                                <div class="font-weight-regular white--text"> <span class="font-weight-bold">Plan Document Maintenance:</span> {{proposalHeaders.proposal.pa_plan_doc_maintenance}}</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols=6 md=3>
                                            <v-container class="pa-0">
                                                <div class="font-weight-regular white--text"> <span class="font-weight-bold">TPA Change Only:</span> {{proposalHeaders.proposal.pa_TPA_change}}</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols=6 md=3 >
                                            <v-container class="pa-0">
                                                <div class="font-weight-regular white--text"> <span class="font-weight-bold">Takeover Type:</span> {{proposalCalcs[0].takeover_type.takeover_name}}</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    -->

                                    <!-- Pricing Assumptions -->
                                    <v-row class="primary mt-8">
                                        <v-col cols="6" xl="8">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Pricing Assumptions</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <div v-if="pricingSection.pricing_assumptions.is_shown">
                                        <v-row v-if="planTypeSection.SubType=='Takeover'">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Assets</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.pricing_assumptions.plan_assets.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Annual Contributions</div>
                                                    </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.pricing_assumptions.annual_contributions.value }}</div>
                                                    </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Participants with a Balance</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.pricing_assumptions.participants_with_balance.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-else> <!-- MEP -->
                                        <v-row v-if="planTypeSection.SubType=='Takeover'">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Assets</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.mep_pricing.plan_assets.value || '-' }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Annual Contributions</div>
                                                    </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.mep_pricing.annual_contributions.value || '-' }}</div>
                                                    </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Setup/Installation Fee (1st Year) -->
                                    <v-row class="primary mt-4">
                                        <v-col cols="6" xl="8">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Setup/Installation Fee (1st Year)</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <div v-if="pricingSection.standard_fees.is_shown">
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Design Installation Fee</div>
                                                    </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.standard_fees.design_installation.value || '-' }}</div>
                                                    </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Install Fee per Participant</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.standard_fees.install_participant.value || '-' }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Design & Plan Document Fee</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.standard_fees.document.value || '-' }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-else>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Sponsor - Plan Document</div>
                                                    </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.mep_pricing.sponsor_document.value }}</div>
                                                    </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Adopting Employer Agreement</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.mep_pricing.adopting_employer.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">MEP Tier Total</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ mepTierTotal }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Annual Administration Fees -->
                                    <v-row v-if="pricingSection.standard_fees.is_shown" class="primary mt-4">
                                        <v-col cols="6" xl="8">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Annual Administration Fees</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="pricingSection.standard_fees.is_shown"><!-- Annual Fee per Participant -->
                                        <v-col cols="6" xl="8" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Annual Fee per Participant</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.standard_fees.annual_participant.value || '-' }}</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="pricingSection.standard_fees.is_shown"><!-- Base Annual Admin Fee -->
                                        <v-col cols="6" xl="8" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Base Annual Admin Fee</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.standard_fees.annual_admin.value || '-' }}</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="pricingSection.plan_doc_maint.is_checked"><!-- Plan Document Maintenance Fee -->
                                        <v-col cols="6" xl="8" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Plan Document Maintenance Fee</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.plan_doc_maint.fee.value || '-' }}</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="pricingSection.audit_fee.is_checked"><!-- Audit Fee -->
                                        <v-col cols="6" xl="8" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Audit Fee</div>
                                            </v-container>
                                        </v-col>
                                        <v-col cols="6" xl="4" class="pb-0">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.audit_fee.fee.value || '-' }}</div>
                                            </v-container>
                                        </v-col>
                                    </v-row>

                                    <!-- 3(16) -->
                                    <div v-if="pricingSection.three_sixteen.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">{{pricingSection.three_sixteen.service_tier.value}} 3(16)</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="pricingSection.three_sixteen.use_basis_points.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Basis Points Fees</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ basis_points_fees }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!pricingSection.three_sixteen.use_basis_points.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Setup and Install Fee</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.three_sixteen.setup_install.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!pricingSection.three_sixteen.use_basis_points.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Base Annual Admin Fee</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.three_sixteen.annual_admin.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!pricingSection.three_sixteen.use_basis_points.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Annual Fees Per Participant</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.three_sixteen.annual_participant.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="pricingSection.three_sixteen.calculate_on_opt.value=='eligible' && !pricingSection.three_sixteen.use_basis_points.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Eligible Participants</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.three_sixteen.participants_eligible.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Payroll Integration -->
                                    <div v-if="pricingSection.payroll_integration.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Payroll Integration</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Base Fee</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_integration.pi_base_fee.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Number of Payrolls</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_integration.pi_num_payroll.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Per Employee</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_integration.pi_per_emp.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Number of Employees</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_integration.pi_num_emp.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Payroll Processing -->
                                    <div v-if="pricingSection.payroll_processing.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Payroll Processing</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Per Payroll</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_processing.unit_price.value || "-" }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Number of Payrolls</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.payroll_processing.quantity.value || "-" }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Custom Additions -->
                                    <div v-if="pricingSection.custom_additions.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Custom Additions</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <div v-for="group in pricingSection.custom_additions.groups" :key="group.id">
                                            <v-row v-if="group.is_checked.value">
                                                <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">{{ group.description.value }}</div>
                                                    </v-container>
                                                </v-col>
                                                <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ group.value.value }}</div>
                                                    </v-container>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>

                                    <!-- Custom Notes -->
                                    <div v-if="pricingSection.custom_notes.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">Custom Notes</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <div v-for="group in pricingSection.custom_notes.groups" :key="group.id">
                                            <v-row v-if="group.is_checked.value">
                                                <v-col cols="6" xl="8" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">{{ group.description.value }}</div>
                                                    </v-container>
                                                </v-col>
                                                <v-col cols="6" xl="4" class="pb-0">
                                                    <v-container class="pt-0 pb-0">
                                                        <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ group.value.value }}</div>
                                                    </v-container>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>

                                    <!-- PBGC -->
                                    <div v-if="pricingSection.pbgc.is_checked">
                                        <v-row class="primary mt-4">
                                            <v-col cols="6" xl="8">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-right">PBGC</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular white--text text-center">Amount</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="pricingSection.pbgc.premium_filing.value">
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Comprehensive Premium Filing</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.pbgc.premium_filing.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" xl="8" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-right">Per Participant</div>
                                                </v-container>
                                            </v-col>
                                            <v-col cols="6" xl="4" class="pb-0">
                                                <v-container class="pt-0 pb-0">
                                                    <div class="text-md-h6 text-subtitle-1 font-weight-regular text-center">{{ pricingSection.pbgc.per_participant.value }}</div>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Gross Estimate -->
                                    <v-row class="primary mt-4">
                                        <v-col cols="12" xl="8">
                                            <v-container class="pt-0 pb-0">
                                                <div class="text-center text-md-h6 font-weight-regular white--text ">
                                                    Gross Estimate
                                                </div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols=12 class="pr-0 pl-0">
                                            <PropGrossEstimate />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <!-- Record Keeping Credits -->
                            <v-card v-if="showCredits">
                                <v-card-title class="primary section-title">
                                    <div class="white--text text-h5 font-weight-regular">Record Keeping Credits</div>
                                </v-card-title>
                                <v-card-text>
                                    <div class="pa-4 mt-3 text-h6" v-for="vm in proposalViewModels" :key="vm.id" >
                                        {{vm.packet.rk_name}}
                                        <span :class="mobile ? '' : 'float-right'">
                                            <PropRecordKeepingCredit :viewModel="vm" />
                                        </span>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card-text>
                            </v-card>

                            <!-- Rendered Proposals -->
                            <v-card v-if="showProposals" class="mt-12">
                                <v-card-title class="primary section-title">
                                    <div class="white--text text-h5 font-weight-regular">Proposals</div>
                                </v-card-title>
                                <v-card-text>
                                    <div class="pa-4 mt-3 text-h6" v-for="obj in savedProposals" :key="obj.id">
                                        {{obj.rk_name}}
                                        <span :class="mobile ? '' : 'float-right'">
                                            <ProposalQueueReview :id="obj.proposal_id" :detail="obj" :status="obj.queue_status" />
                                        </span>
                                        <v-divider></v-divider>
                                    </div>
                                </v-card-text>
                            </v-card>

                            <!-- Email Recipients -->
                            <v-row v-if="!showProposals">
                                <v-col cols=12>
                                    <v-container>
                                        <v-combobox
                                        chips
                                        multiple
                                        outlined
                                        label="Email Recipients"
                                        :items="userList.users"
                                        v-model="emailRecipients"
                                        item-text="user_email"
                                        item-value="user_email"
                                        :return-object="false"
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                :key="JSON.stringify(data.item)"
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                :disabled="data.disabled"
                                                color="primary"
                                                dark
                                                close
                                                @click:close="data.parent.selectItem(data.item)"
                                                >
                                                <v-avatar                                                    
                                                    class="accent white--text"
                                                    left
                                                    v-text="data.item.slice(0, 1).toUpperCase()"
                                                ></v-avatar>
                                                {{ data.item }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-tooltip top v-if="!showProposals">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                    large
                                    color="orange darken-2"
                                    dark
                                    class="ma-2"
                                    style="padding-right:16px;"
                                    v-on="on"
                                    elevation=0
                                    @click="backToBuilder"
                                    >
                                    <v-icon left>mdi-arrow-left</v-icon>
                                    Back
                                    </v-btn>
                                </template>
                                <span>Return to proposal builder.</span>
                            </v-tooltip>
                            <v-tooltip top v-if="!showProposals">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                    large
                                    color="primary"
                                    dark
                                    class="mr-2 mr-md-5 ml-2 ml-md-5"
                                    v-on="on"
                                    elevation=0
                                    @click="generateAndSend"
                                    >
                                    Generate & Send Email
                                    </v-btn>
                                </template>
                                <span>Generate Proposal PDFs</span>
                            </v-tooltip>
                            <v-tooltip top class="mr-2 mr-md-5 ml-2 ml-md-5" v-if="showProposals">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                    large
                                    color="primary"
                                    dark
                                    class="mr-2 mr-md-5 ml-2 ml-md-5"
                                    v-on="on"
                                    elevation=0
                                    @click="submit"
                                    >
                                    Close
                                    </v-btn>
                                </template>
                                <span>Completed reviewing and building proposals</span>
                            </v-tooltip>
                        </v-card-actions>
                    </v-card>
                </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PropRecordKeepingCredit from '@/components/proposalcomps/PropRecordKeepingCredit.vue';
import ProposalQueueReview from '@/components/proposalcomps/ProposalQueueReview.vue'
import PropGrossEstimate from '@/components/proposalcomps/PropGrossEstimate.vue';
import ProposalReviewGeneralInfo from '@/components/proposalcomps/ProposalReviewGeneralInfo.vue';
import {safeInt} from '@/store/global_helpers/utility.js';
  
  export default {
    components:{
        ProposalReviewGeneralInfo,
        PropGrossEstimate,
        PropRecordKeepingCredit,
        ProposalQueueReview,
    },

    data: () =>({
      showProposals: false,
      showComponent: false,
      showComplete: false,
      panels: [0,1],
      emailRecipients: [],
      plan_runner: {},
      on: null,
    }),

    props: {
        updateMode: [Boolean],
        proposalContext: [Object],
        duration: [Number],
    },

    watch: {
        userObject() {
            if(this.userObject !== null && this.userObject !== undefined){
                this.plan_runner = this.userObject
                
                let email = this.plan_runner.email
                let plan_runner_filter = this.emailRecipients.filter(function(recipient) {
                    return recipient === email
                })
                if(plan_runner_filter.length === 0){
                    this.emailRecipients.push(this.plan_runner.email)
                }
            }
        }
        
    },

    mounted () {
        window.scrollTo(0, 0)
    },

    computed: {
      ...mapGetters({
            proposalViewModels: 'getProposalViewModels',
          planOpportunityViewmodel: 'getplanOpportunityViewmodel',
          planTypeSection: 'getPlanTypeSection',
          pricingSection: 'getPricingSection',
          savedProposals: 'getSavedProposals',
          isPDFGenerated: 'getIsPDFGenerated',
          proposalHeaders: 'proposalHeaders', 
          userList: 'userList', 
          userObject: 'userObject'
        }),
        
        showCredits(){
            return this.planTypeSection.ParentType != 'Cash Balance Only' && !this.planTypeSection.IsNoRevenueShare;
        },

        mepTierTotal(){
            let t = 0;
            this.pricingSection.mep_pricing.groups.forEach(g => {
                t += g.total;
            });
            return t;
        },

        basis_points_fees(){
            let points = 0 
            if (this.pricingSection.three_sixteen.basis_points.value) {
                points = safeInt(this.pricingSection.three_sixteen.basis_points.value);
            }
            let assets = 0
            if (this.pricingSection.mep_pricing.is_shown){
                assets = safeInt(this.pricingSection.mep_pricing.plan_assets.value);
            } else {
                assets = safeInt(this.pricingSection.pricing_assumptions.plan_assets.value);
            }
            return Number(assets * (points * .0001)).toLocaleString("US", {
                currency: "USD"
              });
        },

        min_width () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return 200;
              case 'sm': return 400;
              case 'md': return 800;
              case 'lg': return 800;
              case 'xl': return 1200;
            }
            return null
        },

        mobile () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return true;
              case 'sm': return true;
              case 'md': return false;
              case 'lg': return false;
              case 'xl': return false;
            }
            return null
        },

        plan_assets(){
             let contrib = 0
            if (!isNaN(this.proposalHeaders.proposal.pa_plan_assets)) {
                contrib = this.proposalHeaders.proposal.pa_plan_assets
            }
            return Number(contrib).toLocaleString("US", {
                currency: "USD"
              });
        },
        
        pa_annual_contribution(){
           
            return Number(this.proposalHeaders.proposal.pa_annual_contribution).toLocaleString("US", {
                currency: "USD"
              });
        },

        pp_plan_design_installation_fee(){
            return Number(this.proposalHeaders.proposal.pp_plan_design_installation_fee).toLocaleString("US", {
                currency: "USD"
              });
        },    

        pp_audit_fee(){
            return Number(this.proposalHeaders.proposal.pp_annual_audit_fee).toLocaleString("US", {
                currency: "USD"
              });
        }, 

        pp_install_participant_fee(){
            return Number(this.proposalHeaders.proposal.pp_install_participant_fee).toLocaleString("US", {
                currency: "USD"
              });
        },

        pp_document_fee(){
            return Number(this.proposalHeaders.proposal.pp_document_fee).toLocaleString("US", {
                currency: "USD"
              });
        },

        pp_annual_participant_fee(){
            return Number(this.proposalHeaders.proposal.pp_annual_participant_fee).toLocaleString("US", {
                currency: "USD"
              });
        },   

        pp_annual_admin_fee(){
            return Number(this.proposalHeaders.proposal.pp_annual_admin_fee).toLocaleString("US", {
                currency: "USD"
              });
        },

        pp_document_maintenance_fee(){
            return Number(this.proposalHeaders.proposal.pp_document_maintenance_fee).toLocaleString("US", {
                currency: "USD"
              });
        },

        setup_install_fee_3_16(){
            return Number(this.proposalHeaders.proposal.setup_install_fee_3_16).toLocaleString("US", {
                currency: "USD"
              });
        },

        annual_admin_fee_3_16(){
            return Number(this.proposalHeaders.proposal.annual_admin_fee_3_16).toLocaleString("US", {
                currency: "USD"
              });
        },

        annual_participant_fee_3_16(){
            return Number(this.proposalHeaders.proposal.annual_participant_fee_3_16).toLocaleString("US", {
                currency: "USD"
              });
        },        
    },
    
    methods:{
        ...mapActions([
            'clearProposalViewModels',
            'saveProposalViewModels',
            'checkQueue',
            'downloadProposalPDF',
            'saveProposals', 
            'sendEmail', 
            'getOtherUserObject',
            'getProposalList'
        ]),
      
        backToBuilder(){
            this.clearProposalViewModels();
            this.$emit('return', 'Builder');
        },
      
        destroy: function() {
            this.$refs.ProposalQueueReview.removeInterval();
        },

        generateAndSend(){
            // console.log('generateAndSend called');
            this.saveProposalViewModels(this.generateEmailObject);
            this.showProposals = true;
        },
      
        generateEmailObject(){
            // console.log('generateEmailObject called')
            if(this.emailRecipients.length > 0){
                let emailObj = {}

                emailObj['plan_opportunity_id'] = this.planOpportunityViewmodel.plan_opportunity.plan_opportunity_id;
                emailObj['to'] = [];
                this.emailRecipients.forEach((r) => {
                    emailObj['to'].push(r);
                })
                this.sendEmail(emailObj);
            }
        },

        submit() {
            if(this.mobile){
                this.$router.push({
                    name: 'dashboard',
                })
            } else {
                this.$emit('return', 'List');
            }
        },
    }
};
</script>

<style type="text/css" scoped>
    .section-title{
        bottom-right-border-radius: 0;
        bottom-left-border-radius: 0;
    }
    .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }
    .rounded-card {
        border-radius: 20px !important;
    }
</style>
